export default __webpack_public_path__ + "static/media/detected-text-img.c777e52a.png";